import EventState from "./EventState";

// TODO: once MeetingCenter is permanently removed,
// migrate the event state object to this module instead.
export default EventState;

export const isValid = meetingState => {
	return Object.values( EventState ).includes( meetingState );
};



// WEBPACK FOOTER //
// ./src/constants/MeetingState.js